import { render, staticRenderFns } from "./UserHello.vue?vue&type=template&id=53eb11d2&"
import script from "./UserHello.vue?vue&type=script&lang=js&"
export * from "./UserHello.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports